
import {
    SELECT_QUERY,
    SET_ATTR_CONDITION,
    SET_GEOM_CONDITION,
    SET_IS_GEO_ACTIVE,
    SET_IS_VALID,
    SET_PARAM_VALUE
} from '../sagas/ui';

import { Log } from '../../core';
const log = Log.getLogger('MultiSceneForApp.search.reducer.ui');

const initialState = {
    attrConditions: {},
    geomCondition: null,
    isGeoActive: false,
    isValid: false,
    queryId: null,
    queryType: null,
    paramValues: {}
};

export function getAttrConditions(state) {
    return state.attrConditions;
}

export function getGeomCondition(state) {
    return state.geomCondition;
}

export function getIsGeoActive(state) {
    return state.isGeoActive;
}

export function getIsValid(state) {
    return state.isValid;
}

export function getParamValues(state) {
    return state.paramValues;
}

export function getQueryId(state) {
    return state.queryId;
}

export function getSearchData(state) {
    switch (state.queryType) {
        case 'ATTRIBUTES':
            return {
                attrs: Object.keys(state.attrConditions)
                    .filter(item => !!state.attrConditions[item])
                    .map(item => {
                        return {
                            id: item,
                            operator: state.attrConditions[item].operator,
                            value: state.attrConditions[item].value
                        };
                }),
                geom: state.isGeoActive ? state.geomCondition : null
            };
        case 'PARAMS':
            return {
                params: Object.keys(state.paramValues).map(item => {
                    return {
                        id: item,
                        value: state.paramValues[item]
                    };
                })
            };
        default:
            // nop;
    }
}

function selectQuery(state, action) {
    return {
        ...state,
        attrConditions: {},
        queryId: action.queryId,
        queryType: action.queryType,
        paramValues: {}
    };
}

function calculateIsValid(attrConditions, geomCondition, isGeoActive) {
    let count = Object.keys(attrConditions).reduce((previous, current) => {
        return (attrConditions[current])
            ? previous + 1
            : previous;
    }, 0);

    return (count > 0) || (geomCondition && isGeoActive)
}

function setAttrCondition(state, action) {
    let newAttrConditions = {
        ...state.attrConditions,
        [action.attrId]: action.condition
    };

    return {
        ...state,
        attrConditions: newAttrConditions,
        isValid: calculateIsValid(
            newAttrConditions, state.geomCondition, state.isGeoActive
        )
    };
}

function setGeomCondition(state, action) {
    let geomCondition = (action.geometry && action.condition)
        ? {
            geometry: action.geometry,
            condition: action.condition
        }
        : null;

    return {
        ...state,
        geomCondition: geomCondition,
        isValid: calculateIsValid(
            state.attrConditions, geomCondition, state.isGeoActive
        )
    };
}

function setIsGeoActive(state, action) {
    return {
        ...state,
        isGeoActive: action.active,
        isValid: calculateIsValid(
            state.attrConditions, state.geomCondition, action.active
        )
    };
}

function setIsValid(state, action) {
    return {
        ...state,
        isValid: action.isValid
    };
}

function setParamValue(state, action) {
    return {
        ...state,
        paramValues: {
            ...state.paramValues,
            [action.paramId]: action.value
        }
    }
}

function ui(state = initialState, action) {
    switch (action.type) {

        case SELECT_QUERY:
            return selectQuery(state, action);

        case SET_ATTR_CONDITION:
            return setAttrCondition(state, action);

        case SET_GEOM_CONDITION:
            return setGeomCondition(state, action);

        case SET_IS_GEO_ACTIVE:
            return setIsGeoActive(state, action);

        case SET_IS_VALID:
                return setIsValid(state, action);

        case SET_PARAM_VALUE:
            return setParamValue(state, action);

        default:
            return state;
    }
}

export default ui;
